import React, { useEffect, useState } from 'react';
import { TatbestandEditor } from './components/TatbestandEditor';
import { ArbeitsplatzVerwaltung } from './components/ArbeitsplatzVerwaltung';
import { MitarbeiterVerwaltung } from './components/MitarbeiterVerwaltung';
import { FaelligkeitenListe } from './components/FaelligkeitenListe';
import { useHandoffStore } from '../../store/handoffStore';

type VorsorgeTab = 'faelligkeiten' | 'mitarbeiter' | 'tatbestaende' | 'arbeitsplaetze';

const TABS: { key: VorsorgeTab; label: string; icon: string }[] = [
  { key: 'faelligkeiten',  label: 'Fälligkeiten',     icon: '🩺' },
  { key: 'mitarbeiter',    label: 'Mitarbeiter',      icon: '👥' },
  { key: 'tatbestaende',   label: 'VGÜ-Tatbestände',  icon: '📋' },
  { key: 'arbeitsplaetze', label: 'Arbeitsplätze',    icon: '🏭' },
];

export function VorsorgeModul(): React.JSX.Element {
  const [tab, setTab] = useState<VorsorgeTab>('faelligkeiten');

  /* Übergabe „Als Mitarbeiter anlegen": auf den Mitarbeiter-Tab wechseln
   * (ohne die Payload zu leeren — das macht MitarbeiterVerwaltung). */
  const handoffPayload = useHandoffStore(s => s.payload);
  useEffect(() => {
    if (handoffPayload !== null && handoffPayload.action === 'mitarbeiter') {
      setTab('mitarbeiter');
    }
  }, [handoffPayload]);

  return (
    <div className="flex flex-col h-full">
      {/* Tab-Leiste */}
      <div className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-6 pt-4 flex gap-1">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => { setTab(t.key); }}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors
              ${tab === t.key
                ? 'border-blue-600 text-blue-700 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>

      {/* Inhalt */}
      <div className="flex-1 overflow-y-auto">
        {tab === 'faelligkeiten'  && <FaelligkeitenListe />}
        {tab === 'mitarbeiter'    && <MitarbeiterVerwaltung />}
        {tab === 'tatbestaende'   && <TatbestandEditor />}
        {tab === 'arbeitsplaetze' && <ArbeitsplatzVerwaltung />}
      </div>
    </div>
  );
}
